import axiosInstance from './axiosInstance';

const deleteSlide = (id) =>
  axiosInstance.delete(`/internal/admin/config/carousels/${id}`);

export default deleteSlide;
